import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const GallerySection = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    return (<>
        <section className="py-40 bg-accent flex justify-center items-center">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="flex flex-col items-center"
            >
                <h2 className="text-4xl font-bold mb-10 text-primary">{t(I18N_KEYS.CAMPUSVISITPROMPT)}</h2>
                <motion.button
                    whileHover={{
                        scale: 1.1,
                        backgroundColor: "primary",
                    }}
                    whileTap={{ scale: 0.9 }}
                    onClick={() => navigate("/gallery")}
                    className=" bg-primary text-accent px-8 py-3 text-basesm:px-10 sm:py-4 sm:text-lgmd:px-14 md:py-5 md:text-xl rounded-full font-bold shadow-2xl transition-colors flex items-center gap-1"
                >
                    <span>{t(I18N_KEYS.VISITGALLERYBUTTON)}</span>
                    <span><FaArrowRight /></span>
                </motion.button>
            </motion.div>
        </section>
    </>
    )
}

export default GallerySection;